module.exports = __webpack_public_path__ + "img/hero.f0c1abaa.jpg";